"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// makes a tag to handle url download
var downloadUrl = function downloadUrl(href, fileName) {
  var tempLink = document.createElement('a');
  tempLink.href = href;
  tempLink.setAttribute('download', fileName);
  tempLink.setAttribute('target', '_blank');
  tempLink.click();
  tempLink.remove();
};

var _default = downloadUrl;
exports.default = _default;